import * as PIXI from 'pixi.js';

window.PIXI = PIXI;
require('pixi-spine');
import { Stage } from '@pixi/layers';
import 'Engine/utils/number';
import 'Engine/utils/flashlibExtantion';
import '../assets/scss/styles.scss';
import FlashLib from 'flashlib_onlyplay';
import './Imports';
import BaseGame from 'Engine/BaseGame';
import StatesManager from 'Engine/base/states/StatesManager';
import GameModel from './model/GameModel';
import { StatesConfig } from './states/StatesConfig';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import BaseGameSettings from 'Engine/base/settings/BaseGameSettings';
import AutoPlaySettings from 'Engine/base/settings/AutoPlaySettings';
import ControllerTextField from './textField/ControllerTextField';
import OPWrapperService from 'WrapperService';
import '../submoduleConfigs';
import eEventTypes from './enums/eEventTypes';
import background from '../assets/images/preloader_background.webp';
import gameSizeConfig from './configs/gameSizeConfig';
import wrapperConfig from './configs/wrapperConfig';
import preloaderConfig from './preloader/preloaderConfig';
import 'Preloader/preloader';
import BaseSystemUiAdapter from 'Engine/base/ui/uiAdapter/BaseSystemUiAdapter';
import { eSounds } from './enums/eSoundTypes';

export default new (class Game extends BaseGame {
  constructor(preloaderConfig) {
    EntryPoint.compiled = true;
    super(preloaderConfig);

    EntryPoint.Game = this;
  }

  initStartClasses() {
    this.initWrapperService()
    GameModel.init();
    new BaseGameSettings().init();
    new AutoPlaySettings().init();
    new BaseSystemUiAdapter(window.OPWrapperService.SystemUI).init({
      clickSound: eSounds.EST_BUTTON_CLICK,
    });

    StatesManager.setStatesConfig(StatesConfig);

    FlashLib.TextField = ControllerTextField;

    GlobalDispatcher.add(
      eEventTypes.EET_SPIN_CLICK,
      StatesManager.goToNextState,
      StatesManager
    );
    GlobalDispatcher.add(eEventTypes.EET_BUY_BONUS, () =>
      StatesManager.goToState(eEventTypes.EST_REQUEST_BONUS)
    );
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.drawMask,
      this
    );
  }

  initWrapperService() {
    this.wrapperConfig = {
      ...wrapperConfig,
      scaleData: { data: this.scaleData, config: gameSizeConfig },
    }

    new OPWrapperService(this.wrapperConfig);
  }

  initStartParams() {
    this.gameSize = {
      desktop: {
        width: 2340,
        height: 1080,
      },
      mobileLandscape: {
        width: 2340,
        height: 1080,
      },
      mobilePortrait: {
        width: 1080,
        height: 2340,
      },
    };
    this.scaleData = {
      app: this.app,
      gameSize: this.gameSize,
    };
  }

  createPreloader() {
    super.createPreloader();
    this.preloaderView.style.background = `url(${background}) no-repeat center`;
    this.preloaderView.style.backgroundSize = `cover`;
  }

  constructGame() {
    this.app.stage = new Stage();
    EntryPoint.configData = PIXI.Assets.get('gameConfig');
    this.app.stop();
    this.main = FlashLib.createItemFromLibrary('Main', 'GameFlashLib');
    this.app.stage.addChildAt(this.main, 0);
    const jackpotGame = FlashLib.createItemFromLibrary('jackpotMain', 'jackpotGameFlashLib');
    this.main.addChild(jackpotGame);
    this.main.jackpotGame = jackpotGame;
    this.main.init();

    this.app.renderer.prepare.upload(this.main).then(() => {
      this.app.start();
      GlobalDispatcher.dispatch(eEventTypes.EET_GAME__STARTED);
      this.hidePreloader();
      this.linkToPixi();
    });
  }

  drawMask(data) {
    if(!this.app) return;
    const x = data.isMobile && data.isPortrait ? 630 : 0;
    const y = data.isMobile && data.isPortrait ? -630 : 0;
    if (!this.gameMask) {
      this.gameMask = new PIXI.Graphics();
    } else {
      this.gameMask.clear();
    }
    this.gameMask.beginFill(0xff3300);
    this.gameMask.drawRect(x, y, data.gameWidth, data.gameHeight);
    this.gameMask.endFill();
    this.app.stage.addChild(this.gameMask);
    this.app.stage.mask = this.gameMask;
  }

  onLoadingComplete() {
    this.constructGame();
    window.OPWrapperService.ScaleManager.init(this.scaleData, gameSizeConfig);
  }
})(preloaderConfig);
